export const PRODUCT_LOGS = `
query productLogs(
  $tenant_id: Int!, 
  $skip: Int, 
  $take: Int, 
  $orderBy: ProductLogOrderInput, 
  $filter: FilterProductLogInput
){
productLogs(
  tenant_id:$tenant_id, 
  skip:$skip, 
  take:$take, 
  orderBy:$orderBy, 
  filter:$filter
){
  __typename
  ...on ProductLog{
    id
    log_action{
      name
      translation_key
    }
    its
    user{
      contact{
        firstname
        lastname
      }
    }
    description 
  }
  ...on ResultError{
    status_code
    message
    message_translation_key
  }
}
}
`;

export const PRODUCT_LOGS_WITH_STOCK = `
query productLogsWithStock(
  $tenant_id: Int!
  $skip: Int
  $take: Int
  $filter: FilterProductLogWithStockInput
){
productLogsWithStock(
  tenant_id:$tenant_id
  skip:$skip
  take:$take
  filter:$filter  
){
  __typename
  ...on ProductLogWithStock{
    action_name
    action_translation_key
    its
    user{
      email
      contact{
        firstname
        lastname
      }
    }
    product_specification{
      option_1{
        value
      }
      option_2{
        value
      }
      option_3{
        value
      }
    }
    description
    updated_dimensions
    stock_reason_type
    amount
    product{
      has_variants
    }
  }
  ...on ResultError{
    status_code
    message
    message_translation_key
  }
}
}
`;
